import React from 'react';
import { CalendarIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { TrainingGoalCard } from '../components/TrainingGoalCard';
import { Card } from '../components/ui/Card';
import { goals } from '../data/insights';
import { useLocale } from '../contexts/LocaleContext';
export function Goals() {
  const {
    t,
    tl
  } = useLocale();
  return <div className="px-2 pb-2" data-id="element-3079" data-mp="19t105ybr1r0w">
      <PageHeader title={t('stats.goals.title')} subtitle={t('goals.subtitle')} showBack data-id="element-3080" data-mp="19s817jj185tb" />

      <div className="mb-2" data-id="element-3081" data-mp="14upt1vcu9umd">
        <TrainingGoalCard data-id="element-3082" data-mp="14teohtbkkiu7" />
      </div>

      <ul className="space-y-2" data-id="element-3083" data-mp="1itpfcwcvpxfd">
        {goals.map(goal => {
        const pct = Math.min(100, Math.round(goal.current / goal.target * 100));
        return <li key={goal.id} data-id="element-3084" data-mp="1esvq9znpackw">
              <Card className="p-2" data-id="element-3085" data-mp="3kksspte5lq3m">
                <div className="flex items-baseline justify-between gap-2" data-id="element-3086" data-mp="3km3ytzv2n9xw">
                  <p className="min-w-0 text-[13.5px] font-medium text-deep" data-id="element-3087" data-mp="3gjz2uuh5i183">
                    {tl(goal.title)}
                  </p>
                  <p className="bee-num shrink-0 text-[12px] font-bold text-gold-deep" data-id="element-3088" data-mp="18jms6efmaoct">
                    {pct}%
                  </p>
                </div>

                <p className="bee-num mt-1 text-[12px] text-muted" data-id="element-3089" data-mp="1ifppn6zixytf">
                  {goal.current} {t('goals.of')} {goal.target} {tl(goal.unit)}
                </p>

                <div className="mt-2 h-[7px] w-full overflow-hidden rounded-pill bg-sand-deep" data-id="element-3090" data-mp="1n8rarwqbqulg">
                  <span className="block h-full rounded-pill bg-gold" style={{
                width: `${pct}%`
              }} data-id="element-3091" data-mp="1s8dlnziojyr3" />
                </div>

                {goal.deadline && <p className="mt-2 flex items-center gap-1 text-[11px] text-muted" data-id="element-3092" data-mp="265k39qro3req">
                    <CalendarIcon size={12} aria-hidden="true" data-id="element-3093" data-mp="6sobvc8cm1hc" />
                    {tl(goal.deadline)}
                  </p>}
              </Card>
            </li>;
      })}
      </ul>

      <p className="mt-2 px-1 text-[11px] leading-snug text-muted" data-id="element-3094" data-mp="3qtml2z9uolx">
        {t('goals.note')}
      </p>
    </div>;
}